angular.module('harriApp')
    .controller('ScreeningController', [
        '$scope', '$state', '$stateParams', 'hUser', 'JobDetailsBus', 'outmatchAssessmentService',
        function ($scope, $state, $stateParams, hUser, JobDetailsBus, outmatchAssessmentService) {

            $scope.loading = true;
            let isBulkFlow = false;

            const init = async () => {

                $scope.isEmployer = hUser.isEmployer();
                let jobIds = $stateParams.job_id?.split(',');
                isBulkFlow = jobIds?.length > 1;

                ProfileAPI.getBrandProfile($stateParams.brand_id).then(function (brand) {
                    $scope.brand = brand;
                    $scope.$digest();
                });

                if (!isBulkFlow) {
                    JobDetailsBus.getJob($stateParams.job_id).then((jobDetails) => {
                        $scope.jobDetails = jobDetails;
                    });
                }

                if ($stateParams.form_type === 'EQUAL_EMPLOYMENT_OPPORTUNITY') {
                    const params = {
                        job_ids: $stateParams.job_id
                    };
                    const formData = await EEOAPI.getEeoQuestionsCandidateSettings($stateParams.brand_id, 'EQUAL_EMPLOYMENT_OPPORTUNITY', params);
                    formData.type = $stateParams.form_type;

                    const eeoStandardFormsQuestions = formData.forms.filter(form => form.is_standard).flatMap(form => form.questions);
                    const eeoCustomFormsQuestions = formData.forms.filter(form => !form.is_standard).flatMap(form => form.questions);
                    formData.questions = [...eeoStandardFormsQuestions, ...eeoCustomFormsQuestions];

                    $scope.eeoQuestionsCandidateForm = new EEOQuestionsCandidateForm(
                        $scope,
                        $stateParams.brand_id,
                        $stateParams.job_id
                    );

                    $scope.eeoQuestionsCandidateForm.load(formData);

                    $scope.screeningForm = formData;
                    $scope.loading = false;
                } else {
                    try {
                        const screeningForm = await AQAAFAPI.getScreeningForms(
                            $stateParams.brand_id,
                            $stateParams.job_id,
                            $stateParams.screening_forms_id,
                            $stateParams.form_type
                        );

                        $scope.screeningAnswerForm = new ScreeningAnswerForm(
                            $scope,
                            screeningForm,
                            $stateParams.application_id,
                            $stateParams.job_id,
                            $stateParams.form_type
                        );

                        $scope.screeningForm = screeningForm;
                    } catch (err) {
                        if (err) {
                            switch (err.data) {
                                case "FORM_ALREADY_ANSWERED":
                                    $scope.alreadyAnswered = true;
                                    break;
                                case"NO_ACTIVE_JOB_APPLICATION_FOUND_FOR_THIS_USER":
                                    $scope.invalidUser = true;
                                    break;
                                case "USER_IS_NOT_ALLOWED_TO_ACCESS_THIS_STAGE":
                                    $scope.userNotAllowedToAccess = true;
                                    break;
                                case "INVALID_JOB_SCREENING_FORM_ID":
                                    $scope.invalidForm = true;
                                    break;
                                default:
                                    console.error(err);
                            }
                        } else {
                            console.error(err);
                        }
                    } finally {
                        $scope.loading = false;
                        $scope.$digest();
                    }
                }
            };

            init();

            $scope.skip = () => {
                if (isBulkFlow) {
                    $scope.goToDashboard();
                    return;
                }
                $scope.submitting_complete = true;
                onScreeningFinished();
            }

            $scope.goToDashboard = function () {
                $state.go("appLayout.harriSH.dashboard");
            };

            $scope.optOut = async () => {
                $scope.submittingForm = true;
                try {
                    await $scope.eeoQuestionsCandidateForm.optOutEEOForm();
                    $scope.submitting_complete = true;
                    if (isBulkFlow) {
                        $scope.goToDashboard();
                        return;
                    }
                    onScreeningFinished();
                } catch (e) {
                    console.error(e)
                }
                $scope.submittingForm = false;
            };

            $scope.submitAnswers = () => {
                $scope.submittingForm = true;
                if ($stateParams.form_type === 'EQUAL_EMPLOYMENT_OPPORTUNITY') {
                    $scope.eeoQuestionsCandidateForm.validator.validate(async (isValid) => {
                        if (isValid) {
                            try {
                                const response = await $scope.eeoQuestionsCandidateForm.save();
                                if (response?.data && response?.status_code === 200) {
                                    if (!isBulkFlow) {
                                        onScreeningFinished();
                                    }
                                    $scope.submitting_complete = true;
                                    $scope.$digest();
                                } else {
                                    console.error(response?.data);
                                }
                            } catch (e) {
                                console.error(e);
                            }
                        }
                        $scope.submittingForm = false;
                    });
                } else {
                    $scope.screeningAnswerForm.validator.validate(async (isValid) => {
                        if (isValid) {
                            try {
                                const response = await $scope.screeningAnswerForm.save();
                                if (response?.data?.data && response?.data?.status_code === 200) {
                                    if (!isBulkFlow) {
                                        onScreeningFinished();
                                    }
                                    $scope.submitting_complete = true;
                                    $scope.$digest();
                                } else {
                                    console.error(response?.data);
                                }
                            } catch (e) {
                                console.error(e)
                            }
                        }
                        $scope.submittingForm = false;
                    });
                }
            };

            const onScreeningFinished = () => {
                JobDetailsBus.onJobApplyFinish(JobDetailsBus.EEO_SUCCESS, $stateParams.application_id);
            }

            JobDetailsBus.onJobApplyFinish = async (status, appId, applyDate) => {
                if ([JobDetailsBus.EEO_SUCCESS].indexOf(status) > -1) {
                    if ($scope.jobDetails?.brand?.public_services?.indexOf("WOTC") > -1) {
                        WOTCAPI.getBrandWotcSettings($scope.jobDetails.brand.id)
                            .then(async (res) => {
                                if(res['workflow_mode'] === 'IN_APPLICATION') {
                                    let params = {
                                        brand_id: $scope.jobDetails.brand.id,
                                        app_id: appId || $scope.jobDetails.job.application_id,
                                        jobId: $scope.jobDetails.job.id
                                    }
                                    $state.go('.wotc', params)
                                } else {
                                    await handleOutmatchAssessment($scope.jobDetails, $scope.jobDetails.brand.id, status, appId, $scope.jobDetails.job.id);
                                }
                                $scope.$digest();
                            })
                            .catch(async (err) => {
                                console.error(err);
                                await handleOutmatchAssessment($scope.jobDetails, $scope.jobDetails.brand.id, status, appId, $scope.jobDetails.job.id);
                            })
                    } else {
                        await handleOutmatchAssessment($scope.jobDetails, $scope.jobDetails.brand.id, status, appId, $scope.jobDetails.job.id);
                    }
                } else if([JobDetailsBus.WOTC_NOT_COMPLETED, JobDetailsBus.WOTC_SUCCESS].indexOf(status) > -1) {
                    await handleOutmatchAssessment($scope.jobDetails, $scope.jobDetails.brand.id, status, appId, $scope.jobDetails.job.id);
                }
            };

            const handleOutmatchAssessment = async (jobDetails, brandId, status, appId, jobId) => {
                const nextFlowCallback = () => {};
                await outmatchAssessmentService.processAssessment(jobDetails, brandId, status, appId, jobId, nextFlowCallback);
            };

            $scope.$on(
                "$destroy",
                () => {
                    JobDetailsBus.onJobApplyFinish = () => {};
                }
            );
        }]);